import { useMaestroStore } from '../store/maestroStore';
import { detectPlatform } from '../utils/platform';
import { isRemoteRendererZone } from './rendererConnectivity';
import { TransportCommand } from './TransportCommand';
import { TransportState } from './TransportState';
import { shouldReclaimQueueOwnershipForTrackEnd } from './playUriConfirmation';

function isLocalNativeZone(zone: { id?: string; type?: string } | null | undefined): boolean {
  if (!zone) return false;
  if (zone.type === 'local-native') return true;
  return typeof zone.id === 'string' && zone.id.startsWith('local-native:');
}

function isTauriLocalNativeZone(zone: { id?: string; type?: string } | null | undefined): boolean {
  return detectPlatform().isTauriDesktop && isLocalNativeZone(zone);
}

function isExclusiveLocalNativeQueueSession(): boolean {
  if (!TransportCommand.isExclusiveActive()) return false;
  const store = useMaestroStore.getState();
  if (store.queue.length === 0 || store.queueIndex < 0) return false;
  return isTauriLocalNativeZone(store.discovery?.activeZone);
}

/**
 * Queue track-end advance gate. Honors queue ownership, or exclusive local-native
 * EOS (Isaac) with a reclaim. Blocks network-renderer sessions (Mark Foster).
 */
export function shouldHonorQueueTrackEndAdvance(): boolean {
  if (TransportState.isQueueOwner()) return true;

  // #598 G — Sonos/network queue session with playUri acceptance evidence reclaims ownership.
  if (shouldReclaimQueueOwnershipForTrackEnd()) {
    TransportState.claimTransportOwner('queue');
    return true;
  }

  const store = useMaestroStore.getState();
  const az = store.discovery?.activeZone;
  if (isRemoteRendererZone(az)) return false;

  const renderer = store.activeConnectorRenderer;
  if (renderer?.id && isRemoteRendererZone(renderer as { id?: string; type?: string })) {
    return false;
  }

  if (!isExclusiveLocalNativeQueueSession()) return false;

  TransportState.claimTransportOwner('queue');
  return true;
}
